export const INTERACTION_STATUS = {
    NEW: 'NEW',
    OPENED: 'OPENED',
    FILLED: 'FILLED',
    IN_CALCULATION: 'IN_CALCULATION',
    RESULTS_AVAILABLE: 'RESULTS_AVAILABLE',
    PREDICTION_ERROR: 'PREDICTION_ERROR',
    ERROR: 'ERROR',
    CLOSED: 'CLOSED'
};


export const PRODUCT_TYPE = {
    BQ_ADVISORY_WEALTH: 'BQ_ADVISORY_WEALTH',
    BQ_ADVISORY_BANK: 'BQ_ADVISORY_BANK',
    BQ_SELECTION: 'BQ_ADVISORY_WEALTH',
    ESG: 'ESG' 
}